// @ts-nocheck
import { tsValueToJsonValueFns, jsonValueToTsValueFns, } from "../../../../../runtime/json/scalar";
import { default as serialize, } from "../../../../../runtime/wire/serialize";
import { tsValueToWireValueFns, wireValueToTsValueFns, } from "../../../../../runtime/wire/scalar";
import { default as deserialize, } from "../../../../../runtime/wire/deserialize";
export function getDefaultValue() {
    return {
        agreeMarketing: false,
        agreeMarketingAtDeleted: false,
    };
}
export function createValue(partialValue) {
    return {
        ...getDefaultValue(),
        ...partialValue,
    };
}
export function encodeJson(value) {
    const result = {};
    if (value.agreeMarketing !== undefined)
        result.agreeMarketing = tsValueToJsonValueFns.bool(value.agreeMarketing);
    if (value.agreeMarketingAtDeleted !== undefined)
        result.agreeMarketingAtDeleted = tsValueToJsonValueFns.bool(value.agreeMarketingAtDeleted);
    return result;
}
export function decodeJson(value) {
    const result = getDefaultValue();
    if (value.agreeMarketing !== undefined)
        result.agreeMarketing = jsonValueToTsValueFns.bool(value.agreeMarketing);
    if (value.agreeMarketingAtDeleted !== undefined)
        result.agreeMarketingAtDeleted = jsonValueToTsValueFns.bool(value.agreeMarketingAtDeleted);
    return result;
}
export function encodeBinary(value) {
    const result = [];
    if (value.agreeMarketing !== undefined) {
        const tsValue = value.agreeMarketing;
        result.push([1, tsValueToWireValueFns.bool(tsValue)]);
    }
    if (value.agreeMarketingAtDeleted !== undefined) {
        const tsValue = value.agreeMarketingAtDeleted;
        result.push([2, tsValueToWireValueFns.bool(tsValue)]);
    }
    return serialize(result);
}
export function decodeBinary(binary) {
    const result = getDefaultValue();
    const wireMessage = deserialize(binary);
    const wireFields = new Map(wireMessage);
    field: {
        const wireValue = wireFields.get(1);
        if (wireValue === undefined)
            break field;
        const value = wireValueToTsValueFns.bool(wireValue);
        if (value === undefined)
            break field;
        result.agreeMarketing = value;
    }
    field: {
        const wireValue = wireFields.get(2);
        if (wireValue === undefined)
            break field;
        const value = wireValueToTsValueFns.bool(wireValue);
        if (value === undefined)
            break field;
        result.agreeMarketingAtDeleted = value;
    }
    return result;
}
